"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("./utils");
/**
 * Format the value label.
 *
 * @param {number} value Value to be displayed on value label
 * @param {array} props.tooltipLabels array of labels
 * @param {number} props.min minimum slider value
 * @param {number} props.step slider handler steps
 * @param {function} props.format slider label format
 * @returns {number|string} Formatted value label
 * @private
 */
function formatValueLabel(value, _ref) {
  let {
    tooltipLabels,
    format,
    min,
    step
  } = _ref;
  const valueLabel = tooltipLabels.length > 0 ? tooltipLabels[(value + Math.abs(min)) / step] : value;
  return format(valueLabel);
}

/**
 * Returns rendered value label.
 *
 * @param {React.ComponentPropsWithoutRef} props component props
 * @returns {React.ReactElement} Rendered value label
 * @private
 */
function ValueLabel(props) {
  const {
    rtl,
    value,
    min,
    max,
    clientWidth,
    index
  } = props;
  const dir = rtl ? 'right' : 'left';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ux-slider-value-label",
    key: `value-label-${index}`,
    style: {
      [dir]: (0, _utils.getPositionFromValue)(value, min, max, clientWidth)
    }
  }, formatValueLabel(value, props));
}
ValueLabel.propTypes = {
  rtl: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
  tooltipLabels: _propTypes.default.array,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  clientWidth: _propTypes.default.number,
  step: _propTypes.default.number,
  format: _propTypes.default.func,
  index: _propTypes.default.number
};
var _default = exports.default = ValueLabel;